import { ICenterFiveStarDetail } from './center-five-star-detail';


export interface ICenterFiveStarSurvey {
    centerId: number,
    centerAlias: string,
    centerLiaison: string,
    centerOverallAverage: number,
    workupTreatment: ICenterFiveStarDetail,
    workupConvenience: ICenterFiveStarDetail,
    workupFacility: ICenterFiveStarDetail,
    preOpTreatment: ICenterFiveStarDetail,
    preOpConvenience: ICenterFiveStarDetail,
    preOpFacility: ICenterFiveStarDetail,
    surgeryTreatment: ICenterFiveStarDetail,
    surgeryFacility: ICenterFiveStarDetail,
    atSurgeryConvenience: ICenterFiveStarDetail,
    surgeryConvenience: ICenterFiveStarDetail,
    postSurgerySurgeon: ICenterFiveStarDetail,
    postSurgeryNursing: ICenterFiveStarDetail,
    postSurgeryPainManagement: ICenterFiveStarDetail,
    postSurgeryCaretakerTreatment: ICenterFiveStarDetail,
    neededReimbursement: ICenterFiveStarDetail,
    donationWasFinancialBurden: ICenterFiveStarDetail,
    donationCostWasImportant: ICenterFiveStarDetail,
    allImprovementOpportunities: string,
    allCommendations: string,
    improvementOpportunities: string[],
    commendations: string[]
}
